import type { Store } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../core/primitives/load-status";
import type { ShareTarget } from "../../core/primitives/share-links";

export const SETTINGS_TABS = [
  { id: "general", label: "General" },
  { id: "admins", label: "Team" },
] as const;

export type SettingsTab = (typeof SETTINGS_TABS)[number]["id"];
export type SettingsTabItem = (typeof SETTINGS_TABS)[number];

export const settingsTabOf = (value: string | null): SettingsTab => (value === "admins" ? "admins" : "general");

/** What a provider's hosted onboarding said on the way back. */
export interface CallbackMessage {
  readonly text: string;
  readonly error: boolean;
}

export class StoreSettingsState {
  readonly storeId: Rx<string>;
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly store = new Rx<Store | null>(null);
  readonly tab = new Rx<SettingsTab>("general");
  readonly tabs = new Rx<readonly SettingsTabItem[]>(SETTINGS_TABS);
  readonly callbackMessage = new Rx<CallbackMessage | null>(null);
  /** The shop's public page on hobbyshop.ai; null until it has a handle. */
  readonly share = new Rx<ShareTarget | null>(null);

  constructor(storeId: string) {
    this.storeId = new Rx(storeId);
  }
}

export abstract class StoreSettingsActions {
  abstract selectTab(tab: SettingsTab): void;
  abstract showQr(): void;
  abstract toDashboard(): void;
}
